export default __webpack_public_path__ + "static/media/personal.8076999b.svg";